/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
import NavbarNotAuth from './components/navbarNotAuth'
import { useEffect, useState, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import NavbarTopAdmin from '../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../admin/components/navbarBottomAdmin'
import DivBottom from './components/divBottom'
import axios from 'axios'
import CercaFornitore from './components/cercaFornitore'
import FornitoreDetails from '../userAuth/components/fornitori/fornitoriDetails'

function Fornitori() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const bannerCorrente = searchParams.get('banner')
    const [fornitori, setFornitori] = useState([])
    const [fornitore, setFornitore] = useState({})// dettagli fornitore cliccato 
    const brnInsFoodTruck = useRef()
    const body = useRef()

    async function getFornitori() {
        try {
            const res = await axios.post(`/getArtisti/DESC/id`)
            const rty = res.data.filter(item => item.sezione === "fornitore")
            setFornitori(rty)
        } catch (err) { console.log(err) }
    }

    useEffect(() => {//cosa fare quando clicco previous page
        console.log('bannerCorrente:', bannerCorrente)
        if (bannerCorrente) {
            document.body.style.overflow = 'hidden'
        } else {//quando i banner sono chiusi
            document.body.style.overflow = ''
        }
    }, [bannerCorrente])

    useEffect(() => {
        getFornitori()
        const isRefresh = window.performance //intercetto il ricaricamneto della pagina (F5)
            ?.getEntriesByType('navigation')
            ?.[0].type === 'reload'
        if (isRefresh && searchParams.has('banner')) {//rimuovo 'banner' quando ricarico la pagina
            searchParams.delete('banner')
            setSearchParams(searchParams, { replace: true })
        }
        function lampeggiaSfondo() {
            if (brnInsFoodTruck.current.style.backgroundColor === 'mediumblue') {
                brnInsFoodTruck.current.style.color = 'black'
                brnInsFoodTruck.current.style.backgroundColor = 'gold'
            }
            else {
                brnInsFoodTruck.current.style.backgroundColor = 'mediumblue'
                brnInsFoodTruck.current.style.color = 'whitesmoke'
            }
        }
        const intervallo = setInterval(lampeggiaSfondo, 1000)
        return () => clearInterval(intervallo)
    }, [])

    // useEffect(() => { console.log('fornitore:', fornitore) }, [fornitore])
    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <p style={{ margin: '5rem 0 0 2rem' }}>\<b>fornitori</b></p>
        <CercaFornitore
            flag={bannerCorrente}
            dettagliIsOpen={(e) => { setSearchParams({ banner: e }) }}
            dati={(e) => { setFornitore(e) }} />
        <div className='text-center'>
            <button ref={brnInsFoodTruck} style={{ width: '80%', padding: '10px 5px', backgroundColor: 'red', fontWeight: '700', borderRadius: '10px', fontSize: 'large' }}
                onClick={() => { navigate('/addFornitore', { replace: true }) }}>INSERISCI FORNITORE
            </button>
        </div>

        <div className='mt-4 homePadding' ref={body}>
            {fornitori &&
                fornitori
                    .filter(item => (item.accettazione === 'true'))
                    .map(elem => {
                        let arrImg
                        if (elem.img) arrImg = elem.img.split(',')
                        return (
                            <div key={elem.id} className='mt-2' style={{ padding: '5px 2em' }}>
                                {elem.img &&
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/${arrImg[0]}`}
                                        style={{ width: '200px', height: '130px', objectFit: 'cover' }} />
                                }
                                {/* ----------- NOME AZIENDA -------------------- */}
                                {elem.gruppo &&
                                    <div className='fw-semibold fs-4 mt-2'>{elem.gruppo.toUpperCase()}</div>
                                }
                                {/* -------------- NOME E COGNOME ---------------- */}
                                {elem.nome &&
                                    <div style={{ fontFamily: 'Times New Roman' }} className='mt-1'>
                                        {elem.nome} {elem.cognome}
                                    </div>
                                }
                                {/* ----------------- GENERE ---------------------------- */}
                                <div className='fs-5 text-success'><i>{elem.genere}</i></div>
                                {/* ------------------ CITTA' ---------------------- */}
                                {elem.città && <div className='mt-2'>{elem.città}</div>}
                                {/* ------------------  TELEFONO + EMAIL ------------------- */}
                                {elem.telefono &&
                                    <div className='mt-2' style={{ display: 'grid', gridTemplateColumns: '0.1fr 1fr', gap: '5px' }}>
                                        <div><img src={require('./image/icons8-telefono-cellulare-48.png')} width='25em' /></div>
                                        <div>{elem.telefono}</div>
                                        <div>
                                            <img src={require('./image/icons8-nuovo-messaggio-48.png')} width='25em' />
                                        </div>
                                        <div>{elem.emailUser}</div>
                                    </div>
                                }
                                <button className='btn btn-primary mt-1' onClick={() => {
                                    setFornitore(elem)
                                    setSearchParams({ banner: 'fornitoriDetails' })
                                }}
                                    style={{ fontSize: 'small', fontWeight: '600' }}>
                                    Dettagli
                                </button>
                                <hr style={{ height: '2px', backgroundColor: 'black' }} />
                            </div>
                        )
                    }
                    )
            }
        </div>
        {fornitore && <FornitoreDetails flag2={bannerCorrente} fornitore={fornitore} />}
        <DivBottom />
    </>)
}
export default Fornitori